import React, {useState, useEffect} from 'react';
import axios from 'axios';

const ContactDetails = () =>{

    const[contact,setContact]= useState([]);
  
    useEffect(()=>{
        axios.get("https://www.cadandrender.com/adminPanel/API/contact.php").then((response)=>{
        setContact(response.data.Contact);
    })
    },[]);

    return(
        <>
        <div className="cad-contact-details">
            {contact.map((res) => (
            <ul>
                <li>
                    <i className="fa fa-phone"></i>
                    <a href={`tel: ${res.CadContact_ContactNumber}`} target="_blank" rel="noreferrer">{res.CadContact_ContactNumber}</a>
                </li>
                <li>
                    <i className="fa fa-envelope-o"></i>
                    <a href={`mailto: ${res.CadContact_Email}`} target="_blank" rel="noreferrer">{res.CadContact_Email}</a>
                </li>
                <li>
                    <i className="fa fa-map-marker"></i>
                    <a href={`${res.CadContact_LocationUrl}`} target="_blank" rel="noreferrer">{res.CadContact_Address}</a>
                </li>
                <li>
                    <i className="fa fa-clock-o"></i>
                    {res.CadContact_Timing}
                </li>
            </ul>
            ))}
        </div>
        </>
    )
}

export default ContactDetails